/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Rs } from './Rs';

class User extends Rs {
    constructor() {
        super();
        this.baseUrl += '/user';
    }

    menu(config) {
        return super.get('/menu', {}, config);
    }

    data({ orgId, userName, fullName, userStatus, isShopStoreUser, storeIdNE, currentPage, pageSize } = {}) {
        return super.get('/data', {
            orgId,
            userName,
            fullName,
            userStatus,
            isShopStoreUser,
            storeIdNE,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, departmentId, userName, fullName, userStatus, employeeId } = {}) {
        return super.post('/save', {
            id,
            departmentId,
            userName,
            fullName,
            userStatus,
            employeeId,
        });
    }

    exists({ id, userName, departmentId } = {}) {
        return super.get('/exists', {
            id,
            userName,
            departmentId,
        });
    }

    resetPwd({ id } = {}) {
        return super.post('/resetPwd', {
            id,
        });
    }

    getUserRole({ userId } = {}) {
        return super.get('/getUserRole', {
            userId,
        });
    }

    saveUserRole({ userId, roleIds, userAppStr } = {}) {
        return super.post('/saveUserRole', {
            userId,
            roleIds,
            userAppStr,
        });
    }

    // -- 用户登录放在这个模块下不太合理 -------------------------------
    login({ account, password }) {
        return super.post(
            '/login',
            {
                account,
                password: password ? Utils.Md5(password) : password,
            },
            {
                isSuccessTip: true,
            },
        );
    }

    logout() {
        return super.post(
            '/logout',
            {},
            {
                isSuccessTip: true,
            },
        );
    }

    modifyPwdByUser({ password, oldPassword }) {
        return super.post(
            '/modifyPwdByUser',
            {
                password: password ? Utils.Md5(password) : password,
                oldPassword: oldPassword ? Utils.Md5(oldPassword) : oldPassword,
            },
            {
                isSuccessTip: true,
            },
        );
    }

    /**
     * 权限
     * @returns {AxiosPromise<any>}
     */
    menuResource() {
        return super.get('/menuResource');
    }

    /**
     * 清除缓存
     * @returns {AxiosPromise<any>}
     */
    clearCache() {
        return super.post('/clearCache');
    }

    selectByPage({ userName, fullName, currentPage, pageSize } = {}) {
        return super.get('/selectByPage', {
            userName,
            fullName,
            currentPage,
            pageSize,
        });
    }
}

export default new User();
export { User };
